import React from "react";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { Lodging } from "@b2bportal/lodging-api/lib/api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useHotelTags } from "@tenant/hotels";
import { Pill } from "@tenant/ui";
import defaultStyles from "./Tags.module.scss";

export type TagsProps = PlatformComponentProps & {
  hotel: Lodging;
};

export const Tags = ({ hotel }: TagsProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.HotelCardTags,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(styles, CoreHotelsComponent.HotelCardTags);
  const { amenities } = hotel.lodging;

  const { MAX_AMOUNT_OF_TAGS } = useHotelTags();

  const pills = hotel.lodging.amenities
    .slice(0, MAX_AMOUNT_OF_TAGS)
    .map((amenity) => {
      return (
        <Pill key={amenity.displayName} className={cn("pill")}>
          {amenity.displayName}
        </Pill>
      );
    });

  const { t } = useI18nContext();

  const amountOfHiddenTags = amenities.length - pills.length;

  const moreTags = amountOfHiddenTags ? (
    <span className={cn("more-tags")}>
      {t("core-hotels.availabilityPage.results.hotelCard.moreTags", {
        count: amountOfHiddenTags,
      })}
    </span>
  ) : null;

  return (
    <div className={block}>
      {pills}
      {moreTags}
    </div>
  );
};
